<template>
    <div style="max-width:50rem;margin: 2rem auto 0;text-align:center;">
        <p style="margin:0;">We're sorry, the store you are trying to access does not exist in this environment.</p>
        <p style="margin:0;">Please contact <a href="mailto:support@protractor.com">Support</a> and request that it be added.</p>
        <p style="margin:2rem 0 0;">To change the active store, click the <strong>Profile Badge</strong> (top right corner) and select a different store in the <strong>Enterprise Store</strong> dropdown.</p>
    </div>
</template>